module.exports = __webpack_public_path__ + "img/321GO.3f76a841.gif";